import Vue from 'vue'
import $api from '@/shared/services/api'
import loading from '@/shared/plugins/loading'

const TTL_DOMINIO = 5 * 60 * 1000

const chaveCacheDominio = () => 'dominio_dados_' + window.location.host

function leCacheDominio(){
    try {
        const bruto = localStorage.getItem(chaveCacheDominio())
        if(!bruto){
            return null
        }
        const cache = JSON.parse(bruto)
        const idade = cache && cache.ts ? Date.now() - cache.ts : -1
        // Idade negativa = relógio do usuário voltou: sem isso o cache não venceria nunca
        if(idade < 0 || idade > TTL_DOMINIO){
            return null
        }
        return cache.data
    } catch(e){
        return null
    }
}

function gravaCacheDominio(data){
    try {
        localStorage.setItem(chaveCacheDominio(), JSON.stringify({ data, ts: Date.now() }))
    } catch(e){
        return
    }
}

// Campos que o backend atualiza sozinho (ex.: ultimo_acesso a cada login):
// não contam como mudança do domínio, senão a página recarregaria à toa
const CAMPOS_VOLATEIS = ['ultimo_acesso', 'modificado_em', 'dominio_ultima_atualizacao']

function assinaturaDominio(dominio){
    const copia = Object.assign({}, dominio)
    CAMPOS_VOLATEIS.forEach(campo => delete copia[campo])
    return JSON.stringify(copia)
}

function aplicaRedirectProtocolo(dominio){
    if(dominio.utiliza_https == 1 && window.location.protocol == 'http:'){
        loading.show()
        location.href = location.href.replace('http', 'https')
    }
    if(dominio.utiliza_https == 0 && window.location.protocol == 'https:'){
        loading.show()
        location.href = location.href.replace('https', 'http')
    }
}

export default {
    namespaced: true,
    state: {
        dominio: null,
    },
    getters: {
        pegaDominio(state){
            return state.dominio
        },
    },
    mutations: {
        atualizaDominio(state, dominio){
            state.dominio = dominio
        },
    },
    actions: {
        // Roda no load (App.vue) e, com o domínio já na tela, a cada navegação
        // (router). Com cache válido não vai à rede. Quando o domínio que chega
        // é diferente do que está na tela — cache venceu, ou outra aba já
        // trouxe o novo — devolve recarregar: o chat e o tema são aplicados uma
        // vez por load, então só recarregando a aba aberta usa o domínio novo.
        async carregaDominio({ commit, state }){
            const naTela = state.dominio
            let retorno
            const cacheDados = leCacheDominio()
            if(cacheDados && cacheDados.Dominio){
                retorno = { status: 'success', data: cacheDados }
            }else{
                retorno = await $api.cGet(Vue.prototype.$urlBase + '/dominios/dados')
                if(retorno.status != 'success'){
                    // Revalidação de aba aberta que falhou: segue com o que já está na tela
                    if(!naTela){
                        Vue.prototype.$dialog.error(retorno.message || 'Oops! Ocorreu algum erro no sistema.')
                    }
                    return retorno
                }
                gravaCacheDominio(retorno.data)
            }
            const dominio = retorno.data.Dominio
            if(naTela && assinaturaDominio(naTela) != assinaturaDominio(dominio)){
                return Object.assign({}, retorno, { recarregar: true })
            }
            aplicaRedirectProtocolo(dominio)
            if(!naTela){
                commit('atualizaDominio', dominio)
            }
            return retorno
        }
    },
}
